import { render, staticRenderFns } from "./XykAdministration.vue?vue&type=template&id=7774786c&scoped=true"
import script from "./XykAdministration.vue?vue&type=script&lang=js"
export * from "./XykAdministration.vue?vue&type=script&lang=js"
import style0 from "./XykAdministration.vue?vue&type=style&index=0&id=7774786c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7774786c",
  null
  
)

export default component.exports